import { render, staticRenderFns } from "./CompanyDemoForm.vue?vue&type=template&id=06ed890d&"
import script from "./CompanyDemoForm.vue?vue&type=script&lang=js&"
export * from "./CompanyDemoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
